import {useIntl} from 'react-intl'
import {dataToSeries} from '../../utility'
import LineChart from '../components/lineChart'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
export default function NumberOfOrders({
  order,
  period,
}: {
  order?: {
    numberOfOrdersCount: number
    numberOfOrdersChartData: {
      date: string
      value: number
    }[]
  }
  period?: string
}) {
  const intl = useIntl()

  return (
    <div className='position-relative'>
      <div
        className='position-absolute d-flex flex-column justify-content-center align-items-center w-100 my-5'
        /* style={{ zIndex: 9999 }} */
      >
        <span className='fs-1 fw-bold text-secondary'>
          {intl.formatMessage({id: 'ANALYTICS.NUMBER_OF_ORDERS'})}
          <span className='position-relative z-50'>
            <OverlayTrigger
              trigger='hover'
              placement='top'
              overlay={
                <Tooltip>
                  {intl.formatMessage({id: 'ANALYTICS.NUMBER_OF_ORDERS_TOOLTIP'}, {time: period})}{' '}
                  {intl.formatMessage({id: 'REAL_UPDATE'})}
                </Tooltip>
              }
            >
              <i className='bi bi-info-circle text-primary ms-1'></i>
            </OverlayTrigger>
          </span>
        </span>
        <span className='fs-2 text-extra-purple fw-bold'>{order?.numberOfOrdersCount}</span>
      </div>
      <div className='mt-12'>
        <LineChart
          data={dataToSeries(
            intl.formatMessage({id: 'ANALYTICS.NUMBER_OF_ORDERS'}),
            order?.numberOfOrdersChartData || []
          )}
        />
      </div>
    </div>
  )
}
